import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { Link, withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
import { getLatitude } from "../../utils/getLatitude.js";
import { getLongitude } from "../../utils/getLongitude.js";
import { NotificationManager } from "react-notifications";
import "./index.css";
let isMounted = false;


const styles = (theme) => ({
    card: {
        color: theme.palette.secondary.main,
    },
});
const sendProps = (props) => {
    const { classes, ...rest } = props;
    return rest;
};
class UserDashboardNew extends Component {
    constructor() {
        super();

        this.state = {
            update: false,
            showAlert: false,
            showCancellationPolicyAlert: false,
            searchKeyword: '',
            searchCategoryData: [],
            categoryData: [],
            isSuggestingService: false,
            serviceSuggestionValue: '',
            allCategory:[],
            loading:false
        };
    }
    componentDidMount() {
        this.getAllCategoriesFromAPI(this.doneFetchingCategories);

        // isMounted = true;
        // this.getData();
        // this.props.allCategoryAction();
    }
    // getData = () => {
    //     if (isMounted) {
    //         this.props.allCategoryAction();
    //     }
    // };

    getData = () => {

        if (isMounted) {
            this.props.masterCategoryAction();
        }
    };
    componentWillUnmount() {
        isMounted = false;
    }

    handleAlert = () => {
        this.setState({ showAlert: true });
    };
    profileUpdate = () => {
        this.setState({ update: true });
    };
    showProfile = () => {
        this.setState({ update: false });
    };
    updateDone = () => {
        this.setState({ update: false });
        if (this.props.userData.role == ROLE_CUSTOMER) {
            this.props.history.push(`/user/profile`);
        } else if (this.props.userData.role == ROLE_PROVIDER) {
            // this.props.history.push(`/user/dashboard`);
            this.props.history.push(`/provider/dashboard`);
        }
    };

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    onSearch = (keyword) => {
        {
            this.setState({
                searchKeyword: keyword.target.value,
            });
        }
        console.log(keyword)
        if (keyword) {
            this.getSearchCategory(keyword.target.value)
            // this.getSearchCategory(keyword.target.value)
        }
        let keywordlength = keyword.target.value.length

        console.log("lenght", keywordlength)

        if(keywordlength == 0){
            this.setState({
                loading: true,
                searchCategoryData:[] 
            })

        }
    }

    getAllCategoriesFromAPI = async done => {
        var authToken = getCookies();
        var latitude = getLatitude();
        var longitude = getLongitude();
        console.log('latitude', latitude, 'longitude', longitude,);
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/mastercategory/newlist`,
                params: {
                    // search: searchValue,
                    search: this.state.searchKeyword,
                    latitude: latitude,
                    longitude: longitude,
                },
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('SEARCH DATA', data);
            if (data.status == 'OK') {
                this.setState({
                    loading: true,
                    searchCategoryData: data.data,
                    allCategory:data.data
                })
            }
            else {
                this.setState({
                    loading: false
                })
            }
        } catch (error) {
            console.log("====================SEARCH ERRORRRRRR", error);
        }
    }

    doneFetchingCategories = (success, data) => {
        if (success) {
            console.log('Success data', data);
        }
    }

    getSearchCategory = async (searchValue) => {

        try {
            if(searchValue.length > 0){
                const { data } = await Axios({
                    method: 'get',
                    url: `${SERVER_URL}/booking/find-matching-category`,
                    params: {
                        searchetext: searchValue,
                        // search: this.state.searchKeyword,
                    },
                });
    
                console.log('SEARCH DATA', data);
                if (data.data.length > 0) {
    
                    let serviceResults = [];
                    data.data.forEach((category, i) => {
    
                        //let data = this.checkService(category.key);
    
                        this.props.checkServiceAction((category.key),(success)=>{
                            if(success){
                                serviceResults.push(data.data[i])
                            }
    
                            if(serviceResults.length >0){
                                this.setState({
                                    loading: true,
                                    searchCategoryData: serviceResults
                
                                })
                            }else{
                                this.setState({
                                    loading: false,
                                    searchCategoryData: []
                                })  
                            }
                           
                        })
        
                    });
    
                    console.log("filterd array", serviceResults)
                }
                else {
                    this.setState({
                        loading: false,
                        searchCategoryData: []
                    })  

                } 
            }else{
                this.getAllCategoriesFromAPI();
            }
         
        } catch (error) {
            console.log("====================SEARCH ERRORRRRRR", error);
        }
    }


    suggestService = async () => {
        console.log("this.state.serviceSuggestionValue", this.state.serviceSuggestionValue);
        var authToken = getCookies();
        console.log('AUTH TOKEN', authToken);
        try {
            const { data } = await Axios({
                method: 'post', //you can set what request you want to be
                url: `${SERVER_URL}/user/service-suggestion`,
                params: {
                    suggested_name: 'Service suggestion',
                    description: this.state.serviceSuggestionValue
                },
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('servise suggestion DATA', data);
            if (data.status == 'OK') {
                this.setState({
                    serviceSuggestionValue: '',
                    searchKeyword: ''
                })
                NotificationManager.success(data.message, 'Success');
                // this.props.history.push('/user/dashboard')
                this.getAllCategoriesFromAPI(this.doneFetchingCategories);
            }
            else {
                this.setState({
                    loading: false
                })
                NotificationManager.error(data.message, 'Error');
                // this.props.history.push('/user/dashboard')
                this.getAllCategoriesFromAPI(this.doneFetchingCategories);
            }
        } catch (error) {
            console.log("==========================servise suggestion ERRORRRRRR", error);
        }

        // this.props.history.push('/user/confirm_booking',{
        //     bookingDetails: this.state.taskDetailsPrev, 
        //     bookingInfoData: this.state.bookingInfoDataPrev,
        //     aditionalData : aditionalData
        // })
    }

    getTopCategoriesForCarousel = () => {
        console.log("ALL CATEGORIESSSS", this.props.categoryData);
        console.log("Search data", this.state.searchCategoryData);
        console.log("All data", this.props)
        return (
            <div>
                {

                    this.state.searchCategoryData.length > 0 &&
                    <div id="Categories" style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginTop: 20, }}>
                        <h3>Choose Categories</h3>
                        <div id="innerCategories" style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginTop: 20, }}>

                            <div id="inner1Categories" style={{ display: 'flex', flexWrap: 'wrap', marginTop: 20, paddingLeft: 35 }}>

                                {/* // this.state.searchKeyword ? this.state.searchCategoryData : this.props.categoryData
                                // this.props.categoryData
                                // this.state.searchCategoryData */}
                                {
                                    this.state.searchCategoryData.map((category, index) => {
                                        // console.log(category);
                                        if (category.key) {
                                            // this._getRandomColor()
                                            return (
                                                // <Link to='/user/services'>
                                                <div
                                                    className="customservicecardNew"
                                                    id="service_{{category.key}}"
                                                    // onClick={() =>
                                                    //     this.redirectCategory(
                                                    //         category.id, category
                                                    //     )
                                                    // }
                                                    // onClick={() =>
                                                    //     this.popclick(
                                                    //         this.props.categoryData,index
                                                    //     )
                                                    // }
                                                    onClick={() => this.props.history.push(`/user/services/${category.key}`, { categoryData: category })}
                                                    style={{
                                                        // display: "block", 
                                                        paddingTop: 20,
                                                        // background: '#ffffff',
                                                        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)',
                                                        borderRadius: 19,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        // width: '20%',
                                                        // height: '20%',
                                                        transform: `translatex(${this.state.left}px)`,
                                                        transition: "0.3s",
                                                        // marginLeft: -5,
                                                        padding: '10px 0',
                                                        margin: 20,
                                                        // backgroundColor: 'pink'
                                                    }}
                                                // ref={el => (this.container = el)}
                                                >

                                                    <img className="responsive-service-img" style={{
                                                        verticalAlign: "middle", borderStyle: "none",
                                                        width: 90, height: 90, borderRadius: 150,
                                                    }}
                                                        src={category
                                                            .image
                                                            .medium}
                                                        alt={
                                                            category.heading
                                                        } />
                                                    <h4
                                                        className="hovertext"
                                                        style={{
                                                            paddingTop: 10,
                                                            marginTop: 10,
                                                            fontWeight: "500",
                                                            marginBottom: ".5rem",
                                                            fontSize: 20,
                                                            fontFamily: "Avenir",
                                                            alignSelf: "center",
                                                            textAlign: "center",
                                                            borderRadius: 5
                                                        }}>
                                                        {
                                                            category.heading
                                                        }
                                                        {/* heading */}
                                                    </h4>
                                                </div>
                                                // </Link>
                                            );
                                        } else {
                                            return this.renderLoading(
                                                index
                                            );
                                        }
                                    }
                                    )
                                }

                            </div>
                        </div>
                    </div>

                }
                {
                    (this.state.searchKeyword && this.state.searchCategoryData.length < 1) &&
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 50,
                    }}>
                        <p style={{
                            width: '60%',
                            textAlign: 'center',
                            fontSize: 25
                        }}>So sorry, this service is not available in your area yet, but check back soon.</p>
                        <p style={{
                            fontSize: 25,
                            fontWeight: 'bold',
                            marginTop: 20
                        }}>Do you want to suggest this service?</p>
                        {
                            this.state.isSuggestingService
                                ?
                                <textarea
                                    // id="required"
                                    // className="border-0 form-control chat-textarea"
                                    // onKeyUp={this._handleKeyPress.bind(this)}
                                    onChange={(e) => this.setState({
                                        serviceSuggestionValue: e.target.value
                                    })}
                                    value={this.state.serviceSuggestionValue}
                                    placeholder="Please write your suggestion"
                                    style={{
                                        height: '20vh',
                                        width: '23vw',
                                        borderRadius: '10px',
                                        margin: 20
                                    }}
                                />
                                : null
                        }
                        {
                            !this.state.isSuggestingService
                                ?
                                <p
                                    onClick={() => this.setState({
                                        isSuggestingService: true
                                    })}
                                    style={{
                                        background: '#0078ff',
                                        padding: '10px 20px',
                                        color: 'white',
                                        borderRadius: 5
                                    }}
                                >Suggest</p>
                                : null
                        }
                        {
                            this.state.isSuggestingService
                                ?
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    width: '52%'
                                }}>
                                    <p
                                        onClick={() => this.setState({
                                            isSuggestingService: false
                                        })}
                                        style={{
                                            border: '1px solid #0078ff',
                                            padding: '10px 20px',
                                            color: '#0078ff',
                                            borderRadius: 5,
                                            marginRight: 15
                                        }}
                                    >Cancel
                                    </p>
                                    <p
                                        onClick={() => this.suggestService()}
                                        style={{
                                            background: '#0078ff',
                                            padding: '10px 20px',
                                            color: 'white',
                                            borderRadius: 5
                                        }}
                                    >Submit
                                    </p>
                                </div>
                                : null
                        }
                    </div>
                }
            </div>
        )
        /* .slice(0, 4) */

        // let categories1=[],categories2=[];
        // for(let i=0;i<allCategories.length;i+=2){
        //     categories1.push(allCategories[i])
        //     categories2.push(allCategories[i+1]);
        // }


        // let arr = categories1.map((item, index) => {
        //     return (
        //         <div style={{display:"flex",flexFlow:"column",alignItems:"center"}}>
        //             {item}
        //             {categories2[index]}
        //         </div>
        //     )
        // })
        // return arr;
    }

    render() {
        const { userData } = this.props;
        console.log('this.state.searchKeyword', this.state.searchKeyword)
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <div style={{
                                marginTop: 20,
                                marginBottom: 20,
                                padding: 10,
                            }}>
                                <h2 style={{
                                    marginBottom: 20,
                                }}>Book a</h2>
                                <h1>Home Service</h1>
                            </div>
                            <div
                                style={{
                                    // background: "#ccc",
                                    // borderRight: "1px solid #C6CBD4",
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    padding: 10
                                }}
                            >
                                <div
                                    className="col-md-10 pl-4 h-100 cate-search-form responsive-search-box"
                                    style={{
                                        // background: "#eee",
                                        border: "1px solid #C6CBD4",
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        // padding: 10,
                                        marginRight: 10,
                                        borderRadius: 5
                                    }}
                                >
                                    <TextField
                                        className="autocomplete select-search"
                                        id="select-search"
                                        placeholder="Search your services"
                                        autoFocus={this.state.focus}
                                        autoComplete={false}
                                        value={this.state.searchKeyword}
                                        onChange={(event) => this.onSearch(event)
                                            // this.setState({
                                            //     searchKeyword: event.target.value,
                                            // })
                                        }
                                        style={{}}
                                    />
                                </div>
                                {/* <div style={{
                                        background: "#0078ff",
                                        // borderRight: "1px solid #C6CBD4",
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%',
                                        // padding: 10
                                        borderRadius: 5
                                    }}>
                                    <p style={{
                                        textAlign: 'center',
                                        color: 'white',
                                        paddingTop: 10,
                                    }}>Search</p>
                                </div> */}
                            </div>
                            <div style={{
                                marginTop: '30px',
                                marginLeft: '13px',
                                //backgroundColor: 'red'
                                // padding: 10,
                            }}>
                                <div>
                                    {this.getTopCategoriesForCarousel()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(UserDashboardNew));



// WEBPACK FOOTER //
// ./src/views/User/UserDashboardNew.jsx